import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94f42d4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contentys",
  class: "container-fluid"
}
const _hoisted_2 = { class: "header-contentys pt-3 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-2" }, null, -1))
const _hoisted_4 = {
  id: "page-content",
  class: "body-contentys pt-0 overflow-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TempNavBar = _resolveComponent("TempNavBar")!
  const _component_TempSideBar = _resolveComponent("TempSideBar")!
  const _component_TempFooter = _resolveComponent("TempFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TempNavBar),
    _createVNode(_component_TempSideBar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true)
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "content", {}, undefined, true)
      ])
    ]),
    _createVNode(_component_TempFooter)
  ]))
}